<template>
  <div class="rate">
    <div class="table-link" @click="onOpenDialog">设置佣金比例</div>
    <el-dialog v-if="dialogVisible" title="设置佣金比例" :visible.sync="dialogVisible" width="540px" modal-append-to-body
               append-to-body>
      <div class="table-num" v-if="isBatch">已选中{{ ids.length }}个</div>
      <el-form label-width="100px" :model="form" :rules="rules" ref="form">
        <el-form-item label="佣金比例" prop="ratio">
          <el-input v-model="form.ratio" placeholder="输入范围：0~8">
            <template slot="append">%</template></el-input>
          <span class="color-gray"> 佣金=营业额 x 佣金比例</span>
        </el-form-item>
      </el-form>
      <div class="rate-tip">

        <div class="rate-bottom color-pink">
          <div><i class="el-icon-info"></i>温馨提示：</div>
          <div>
            1、此比例是您给分销代理的分佣比例，非平台给您的分佣比例。
          </div>
          <div>
            2、佣金比例设置成功后，对新订单生效。
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
import { matchFractionalPart1 } from "@/utils/regExp";
const DouYinModel = new douYin();
export default {
  props: {
    row: {
      // 行数据
      type: Object,
      default: () => { },
    },
    isBatch: {
      // 是否是批量操作
      type: Boolean,
      default: false,
    },
    ids: {
      // ids的集合
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        type: 0,
        ratio: ''// 佣金比例
      },
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
      rules: {
        ratio: [
          {
            required: true,
            message: "请输入佣金比例 ",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            pattern: matchFractionalPart1,
            message: "请输入数字，最多保留一位小数 ",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value > 8) {
                callback(new Error("请输入小于8的佣金比例"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    // 打开弹框
    onOpenDialog() {
      this.form.ratio = this.row.commissionRate;
      this.dialogVisible = true;
    },
    // 批量操作
    onBatch() {
      if (this.ids && this.ids.length) {
        this.dialogVisible = true;
      } else {
        this.$message.error("请先选择代理");
      }
    },
    // 取消
    onCancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 确定
    onSure() {
      this.saveLoading = true;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = await DouYinModel.setAgentRate({
            ...this.form,
            userUUIDStr: this.row.userUUID,
            miniType:5
          }).finally(() => {
            this.saveLoading = false;
          });
          if (data.data.code === 200) {
            this.onCancel();
            this.$emit("getList");
            this.$message.success(data.data.message);
          } else {
            this.$message.error(data.data.message);
          }
        } else {
          this.saveLoading = false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form {
  margin-top: 20px;

  .el-input {
    width: 213px;
  }

}

.rate {
  &-tip {
    background: #FAFAFA;
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/proxyList/SetProxyCommissionRate.vue